import { z } from 'zod';
import ICheckedSystem from '../../user-form/interfaces/ICheckedSystem';
import ValidationService from '../../../../../common/services/validation';
import IUserFormData from '../../user-form/interfaces/IUserFormData';
import IValidationResult from '../../../../../common/interfaces/IValidationResult';
import AMBEV_DOMAINS from '../../../../../common/constants/ambev-domains';
import i18n from '../../../../../lib/i18n';

const requiredFieldMessage = i18n.t('RequiredFieldMessage');
const invalidInformation = i18n.t('InvalidInformation');
const invalidSystemsMessage = i18n.t('InvalidSystemsMessage');

const isFullNameRequired = i18n.t('UsuarioisFullNameRequired');

const defaultReturnMessages = {
    invalid_type_error: invalidInformation,
    required_error: requiredFieldMessage,
};

const requiredString = () => {
    return z.string(defaultReturnMessages).min(1, requiredFieldMessage);
};

const addCustomIssue = (ctx: z.RefinementCtx, message: string) => {
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message,
    });
};

const checkIfFullName = (data: string, ctx: any) => {
    if (data.split(' ').filter(x => x.length !== 0).length <= 1) {
        addCustomIssue(ctx, isFullNameRequired);
    }
};

const requiredSystemsThirdUsers = (systems: ICheckedSystem[], ctx: any) => {
    const countChecked = systems.filter(x => x.isChecked).length;
    if (countChecked < 1) {
        addCustomIssue(ctx, invalidSystemsMessage);
    }
};

const checkIfInternalUser = (data: string) => {
    if (AMBEV_DOMAINS.some(domain => data.endsWith(domain))) {
        return true;
    }
    return false;
};

const CarrierValidationSchema = () =>
    z.object({
        carrierId: requiredString(),
    });

const ValidationThirdUserSchema = z.object({
    name: requiredString().superRefine((data: any, ctx: any) =>
        checkIfFullName(data, ctx),
    ),
    userCarrier: CarrierValidationSchema(),
    systems: z
        .object({ isChecked: z.boolean() })
        .array()
        .superRefine((data: any, ctx: any) =>
            requiredSystemsThirdUsers(data, ctx),
        ),
});

const validateInfosThirdUser = (userData: IUserFormData): IValidationResult => {
    return ValidationService.validate(ValidationThirdUserSchema, userData);
};

const UserEditFormValidationService = {
    checkIfInternalUser,
    validateInfosThirdUser,
};

export default UserEditFormValidationService;
